import { DateTime } from 'luxon';
import { useDispatch, useSelector } from 'react-redux';

import { FORMAT_DATE } from '../const';
import { ComponentsDispatch, RootState } from '../store';
import { setterGant } from '../store/slices/gantSlice';
import { ItemType } from '../types';
import useEffectBuffer from './useEffectBuffer';

const useControllerGantBorderDate = () => {
    const dispatch = useDispatch<ComponentsDispatch>();
    const itemsList = useSelector<RootState, ItemType[]>((state) => state.gantItems.itemsList);

    useEffectBuffer(
        () => {
            const arrayStartDateInSeconds = itemsList.map((item) => DateTime.fromISO(item.startDate).toSeconds());
            const arrayEndDateInSeconds = itemsList.map((item) => DateTime.fromISO(item.endDate).toSeconds());

            const newStartDate = arrayStartDateInSeconds.length
                ? DateTime.fromSeconds(Math.min(...arrayStartDateInSeconds))
                : DateTime.now();

            const newEndDate = arrayEndDateInSeconds.length
                ? DateTime.fromSeconds(Math.max(...arrayEndDateInSeconds))
                : DateTime.now().plus({ days: 40 });

            dispatch(
                setterGant({
                    startDate: newStartDate.minus({ day: 1 }).toFormat(FORMAT_DATE),
                    endDate: newEndDate.toFormat(FORMAT_DATE),
                }),
            );
        },
        100,
        [itemsList],
    );
};

export default useControllerGantBorderDate;
